export default __webpack_public_path__ + "static/media/ActiveComplaints.b7885f31.svg";